__turbopack_context__.v({
  "categoryLink": "TemplatesHomepages-module__6BWmJa__categoryLink",
  "categoryTitle": "TemplatesHomepages-module__6BWmJa__categoryTitle",
  "container": "TemplatesHomepages-module__6BWmJa__container",
  "featuredSolutions": "TemplatesHomepages-module__6BWmJa__featuredSolutions",
  "fullWidthOnMobile": "TemplatesHomepages-module__6BWmJa__fullWidthOnMobile",
  "galleryItem": "TemplatesHomepages-module__6BWmJa__galleryItem",
  "galleryItemContent": "TemplatesHomepages-module__6BWmJa__galleryItemContent",
  "galleryItemImage": "TemplatesHomepages-module__6BWmJa__galleryItemImage",
  "galleryItemText": "TemplatesHomepages-module__6BWmJa__galleryItemText",
  "productCard": "TemplatesHomepages-module__6BWmJa__productCard",
  "productImage": "TemplatesHomepages-module__6BWmJa__productImage",
  "productName": "TemplatesHomepages-module__6BWmJa__productName",
  "productNameContainer": "TemplatesHomepages-module__6BWmJa__productNameContainer",
  "products": "TemplatesHomepages-module__6BWmJa__products",
  "productsContainer": "TemplatesHomepages-module__6BWmJa__productsContainer",
  "productsSection": "TemplatesHomepages-module__6BWmJa__productsSection",
  "sectionHeader": "TemplatesHomepages-module__6BWmJa__sectionHeader",
  "templatesContainer": "TemplatesHomepages-module__6BWmJa__templatesContainer",
});
